// extracted by mini-css-extract-plugin
module.exports = {"custom-scroll":"Messenger_custom-scroll__287eI","msgArea":"Messenger_msgArea__3pWYg","loadingState":"Messenger_loadingState__1CVkz"};